// Recovered compiled webpack factory 14105. Edit this function expression; run npm run build.
(e, t) => {
  function r(e) {
    let {
        widthInt: t,
        heightInt: r,
        blurWidth: n,
        blurHeight: i,
        blurDataURL: o,
        objectFit: a,
      } = e,
      l = n ? 40 * n : t,
      s = i ? 40 * i : r,
      d = l && s ? "viewBox='0 0 " + l + " " + s + "'" : "";
    return (
      "%3Csvg xmlns='http://www.w3.org/2000/svg' " +
      d +
      "%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='20'/%3E%3CfeColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 100 -1' result='s'/%3E%3CfeFlood x='0' y='0' width='100%25' height='100%25'/%3E%3CfeComposite operator='out' in='s'/%3E%3CfeComposite in2='SourceGraphic'/%3E%3CfeGaussianBlur stdDeviation='20'/%3E%3C/filter%3E%3Cimage width='100%25' height='100%25' x='0' y='0' preserveAspectRatio='" +
      (d ? "none" : "contain" === a ? "xMidYMid" : "cover" === a ? "xMidYMid slice" : "none") +
      "' style='filter: url(%23b);' href='" +
      o +
      "'/%3E%3C/svg%3E"
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getImageBlurSvg", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
